import {createRef} from "../createRef";

export default createRef({
    "id": "EXPENSE_REF",
    "source": "EXPENSE_REF",
    "fields": [
        {   "column": "id", },
        {   "column": "code", },
        {   "column": "name", },
    ],
    filters: [
        {
            column: 'isleaf',
            operator: '=',
            value: 'Y',
            dataType: 'text',
        },
    ]
});
